<template>
  <div>
    <div class="page-header">
      <div class="main-wrapper">
        <img src="@/assets/about/logo.png" alt="美课教育">
        <ul>
          <li>
            <router-link to="/">返回官网</router-link>
          </li>
        </ul>
      </div>
    </div>
<!--    <div class="page page-1">
      <img src="@/assets/about/bg.png" class="page-img" width="100%">
      <div class="page-content">
        <img src="../assets/about/btn1.png" class="top-icon" />
        <div class="main-wrapper content">
          <h3>青少年竞争力，提升基地</h3>
          <h4>美课教育是一家集现代化线上教学培训、课程研发、因材施教的新型教育企业。</h4>
          <h4>专业打造适合7~12岁孩子的专业编程教育内容</h4>
        </div>
      </div>
      <div class="ray top"></div>
      <div class="ray bottom"></div>
    </div> -->
    <div class="page page-2">
      <img src="@/assets/about/bg2.png" class="page-img" width="100%">
      <div class="page-content">
        <div class="main-wrapper">
          <video id="myVideo" src="../assets/about/company.mp4" style="object-fit:fill;" controls></video>
          <h2>美课教育<b>不仅是专业课堂，更是艺术人生</b></h2>
          <p>
            美课教育，成人在线教育优秀品牌，总部位于素有“中国品牌之都”美称的青岛，长期以来，一直贯彻着“以匠心做教育”的理念，致力于通过互联网大数据平台融汇优良的教育资源，结合线上教育的优势，为不同基础、不同年龄的人群提供优良的在线教育服务
          </p>
        </div>
        <div class="ray top"></div>
        <div class="ray bottom"></div>
      </div>
    </div>
    <div class="page page-3">
      <img src="@/assets/about/bg2-1.png" class="page-img" width="100%">
      <div class="page-content">
        <div class="main-wrapper">
          <div class='page-title'>让学习更轻松 让起薪更优越</div>
          <h2 class='page-title'>为什么选择美课教育</h2>
          <div class="content">
            <ul>
              <li>
                <div @mouseenter="enter($event)" @mouseleave="leave($event)" class="li-main" :key="1"
                  :class="{'bg':active==1}">
                  <img src="@/assets/about/btn1.png" class="img-top" />
                  <h4>优秀师资</h4>
                  <p>美课教育拥有一支高水平的师资团队，老师拥有十年以上从业经验，并有高水平专业技能。无死角打造岗位精英。</p>
                  <img src="@/assets/about/ter4yovrm.png" class="card-icon">
                </div>
              </li>
              <li>
                <div @mouseenter="enter($event)" @mouseleave="leave($event)" class="li-main" :class="{'bg':active==2}">
                  <img src="@/assets/about/btn2.png" class="img-top">
                  <h4>课程体系</h4>
                  <p>（专项，精通，全面），紧跟互联网潮流，将前沿的设计融入课程，持续精进课程设计，着重培养学生设计思维和创新能力，做到专一而博）</p>
                  <img src="@/assets/about/ter4yovrm.png" class="card-icon">
                </div>
              </li>
              <li>
                <div @mouseenter="enter($event)" @mouseleave="leave($event)" class="li-main" :class="{'bg':active==3}">
                  <img src="@/assets/about/btn3.png" class="img-top">
                  <h4>一站式服务</h4>
                  <p>全方位陪伴式学习，直播+回放+作业点评+答疑+学习群，专业老师及时答疑解惑，花最少的时间，得到最实用的知识</p>
                  <img src="@/assets/about/ter4yovrm.png" class="card-icon">
                </div>
              </li>
              <li>
                <div @mouseenter="enter($event)" @mouseleave="leave($event)" class="li-main" :class="{'bg':active==4}">
                  <img src="@/assets/about/btn4.png" class="img-top">
                  <h4>无限重学</h4>
                  <p>学员关心的问题：学不会可以重新学吗？可以免费重新跟班再次学习。以学员学精为主</p>
                  <img src="@/assets/about/ter4yovrm.png" class="card-icon">
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page page-4">
      <img src="@/assets/about/bg3.png" class="page-img" width="100%">
      <div class="page-content">
        <div class="main-wrapper">
          <div class='page-title'>学有方法</div>
          <h2 class='page-title'>全场景学习模式</h2>
        </div>
        <div class="box" style="width:1200px;padding-top:80px">
          <ul>
            <li class="flexs">
              <img src="@/assets/about/img01.png" alt="">
              <div class="text-mask">
                <div class="tit">对症下药制定学习计划</div>
                <div class="desc">从兴趣导向入手，创设思维，逐步学习</div>
              </div>
              <div class="text-single">
                对症下药
                <span>制定学习计划</span>
              </div>
            </li>
            <li>
              <img src="@/assets/about/img02.png" alt="">
              <div class="text-mask">
                <div class="tit">学管老师陪伴式学习</div>
                <div class="desc">督促提醒，答疑陪伴，打破场景壁垒</div>
              </div>
              <div class="text-single">
                班主任
                <span>陪伴式学习</span>
              </div>
            </li>
            <li>
              <img src="@/assets/about/img03.png" alt="">
              <div class="text-mask">
                <div class="tit">一课一练式讲评答疑</div>
                <div class="desc">一课一练习，讲师点评，解惑升华</div>
              </div>
              <div class="text-single">
                一课一练式
                <span>讲评答疑</span>
              </div>
            </li>
            <li>
              <img src="@/assets/about/img04.png" alt="">
              <div class="text-mask">
                <div class="tit">阶段式学习能力评测</div>
                <div class="desc">定期评测，认清自己，重点学习</div>
              </div>
              <div class="text-single">
                阶段式学习
                <span>能力测评</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="page page-5">
      <img src="@/assets/about/bg4.png" class="page-img" width="100%" />
      <div class="page-content">
        <div class="">
          <h2 class='page-title'>美课大事记</h2>
          <div class="develoap-body">
            <div style="height: 50px"></div>
            <div class="line"></div>
            <!-- 定义一个滚动范围的父div 并绑定ref=all（方便下方方法中取得此元素最左边位置），必要样式：overflow: hidden; display: flex; justify-content: left; -->
            <div class="carousel" ref="all">
              <!-- 循环数组数据，并绑定ref=demoItem(方便取得循环的每一个元素的最左边位置，并动态添加transform样式) -->
              <div v-for="(item, index) in tableData" :key="index" class="carousel-item"
                :style="'transform: translateX(' + item.translateNum + 'px)'" ref="demoItem" @mouseover="mouseOver"
                @mouseleave="mouseLeave">
                <div>
                  <img src="../assets/about/time-icon.png" class="icon">
                  <div class="year">{{item.year}}</div>
                  <div class="tip">
                    <p>{{item.text}}</p>
                    <p>{{item.text2}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page page-6">
      <img src="@/assets/about/bg5.png" class="page-img" width="100%">
      <div class="page-content">
        <h1>不仅是专业课堂，更是艺术人生</h1>
        <div onclick="__egeelTalk()" class="button">联系我们</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Scroll from 'vue-seamless-scroll'
  export default {
    name: 'about',
    components: {
      Scroll
    },
    data() {
      return {
        translateNum: 0,
        timer: null,
        active: 0,
        tableData: [{
            year: '2022年05月',
            text: '美课学员已达成20W+',
            text2: ''
          },
          {
            year: '2022年01月',
            text: '美课教育已推出课程达20套+',
            text2: ''
          },
          {
            year: '2021年06月',
            text: '美课公益中心成立',
            text2: ''
          },
          {
            year: '2021年03月',
            text: '济南分公司成立',
            text2: ''
          },
          {
            year: '2020年01月',
            text: '合肥分公司成立',
            text2: ''
          },{
            year: '2019年12月',
            text: '荣获腾讯2019回响中国',
            text2: '“知名在线教育品牌”'
          },{
            year: '2019年08月',
            text: '美课教育荣获“沃学奖”',
            text2: ''
          },{
            year: '2019年03月',
            text: '美课教育正式成立',
            text2: ''
          }

        ]
      }
    },

    beforeDestroy() {
      // 销毁定时器，否则可能导致重载此组件时会有多个定时器同时执行，使得滚动变快
      window.clearTimeout(this.timer);
    },

    mounted() {
      this.search();
      let lis = document.querySelectorAll('.box>ul>li')
      for (var i = 0; i < lis.length; i++) {
        lis[i].onmousemove = function(e) {
          let li = document.getElementsByClassName('flexs')[0]
          li.classList.remove('flexs')
          e.currentTarget.classList.add('flexs')
        }
      }
    },
    methods: {
      enter(e) {
        e.currentTarget.className = 'li-main bg'
      },
      leave(e) {
        e.currentTarget.className = 'li-main'
      },
      search() {
        // 循环给tableData数组每一个对象添加translateNum属性为0，这也是为了方便记录每一个对象滚动的宽度
        for (var i = 0; i < this.tableData.length; i++) {
          this.$set(this.tableData[i], 'translateNum', 0);
        }
        // 在元素完全渲染后再循环给每一个对象添加indexLeft属性，记录此对象初始位置，方便滚动超出父元素边界后，重新设置元素位置
        this.$nextTick(() => {
          for (var j = 0; j < this.tableData.length; j++) {
            this.$set(this.tableData[j], 'indexLeft', this.$refs.demoItem[j].offsetLeft);
          }
          // 调用滚动定时器
          this.roll();
        })
      },
      roll() {
        this.timer = setInterval(() => {
          // 循环给每一个对象修改translateNum属性值，从而动态修改页面元素的transform样式，达到滚动的效果
          for (var i = 0; i < this.tableData.length; i++) {
            /**
             * 判断此元素是否即将超出父级元素carousel-item的显示区域
             * 1400 = 父级元素carousel的宽度 + 一个子元素carousel-item的宽度（如果元素有间距也需要带上）即 1200 + 180 + 20(间距)
             * 修改父级元素与子元素样式时需要留意此处也应当一起修改
             */
            if (2220 - this.tableData[i].translateNum - this.tableData[i].indexLeft < 0) {
              /**
               * 如果超出，则将元素移动至父级元素显示区域的左方
               * 此处的200 对应着子元素carousel-item的样式宽度
               */
              this.$set(this.tableData[i], 'translateNum', this.$refs.all.offsetLeft - this.tableData[i].indexLeft -
                300);
            }
            // 设置每个元素每次滚动的像素大小，像素越小越平滑,这里每次只移动一个像素
            this.$set(this.tableData[i], 'translateNum', this.tableData[i].translateNum + 1);
          }
        }, 10); // 30毫秒滚动一次，时间间隔越短滚动越平滑
      },

      mouseOver() {
        window.clearTimeout(this.timer);
      },

      /**
       * 鼠标离开再次执行定时器
       */
      mouseLeave() {
        this.roll();
      },

    }
  }
</script>
<style>
  /* 大事记 */
  .page-5 {
    height:620px;
  }

  .page-5 .page-content {
    margin-top:15vh;
  }

  .develoap-body {
    position: relative;
    margin-top: 80px;
    color: white;
    font-family: PingFang SC, \\82F9\65B9, Microsoft YaHei, \\5FAE\8F6F\96C5\9ED1, Lantinghei SC;
  }

  .carousel {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: left;
    z-index: 2;
  }

  .carousel-item {
    width: 400px;
    /* position: relative; */
    text-align: left;
  }

  .carousel-item .year{
    margin-top:30px;
  }

  /**/
  .line {
    z-index: 0;
    width: 100%;
    height: 2px;
    position: absolute;
    left: 50%;
    top: 36%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .2) 26.88%, #fff 50.28%, hsla(0, 0%, 100%, .2) 73.78%, hsla(0, 0%, 100%, 0));
  }

  .icon {
    display: block;
    width: 86px;
    height: 85px;
    z-index: 2;
    overflow: auto;
  }

  .year {
    height: 30px;
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    margin: 8px 0 25px 0;
  }

  .tip {
    width: 330px;
  }

  .tip p {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    margin-right: 70px;
  }

  .tip p:last-child {
    margin-top: 25px;
  }

  .my-outbox {
    overflow: hidden;
    position: relative;
    height: 150px;
  }

  .my-inbox {
    white-space: break-all;
    position: absolute;
    font-size: 0;
  }

  .my-list {
    width: 450px;
    font-size: 13px;
    height: 150px;
  }

  .my-uname {
    color: #FF8900;
  }

  html,
  body {
    font-size: 81.25px !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }

  a {
    color: white;
  }

  .page-header {
    color: white;
    height: 60px;
    position: fixed;
    z-index: 9999;
    top: 0;
    width: 100%;
    background: rgba(0, 0, 0, .2);
    backdrop-filter: blue(30px);
    transition: background 0.4s ease 0s, box-shadow 0.4s ease 0s;
  }

  .page-header img {
    margin-top: 0.25rem;
    float: left;
    width: 120px;
  }

  .page-header ul {
    float: right;
    line-height: 60px;
  }

  .main-wrapper {
    max-width: 1200px;
    font-size: 0.2rem;
    width: 100%;
    margin: 0 auto;
  }

  .page {
    min-height: 50vh;
    width: 100%;
    position: relative;
  }

  .page-wrap {
    height: 100vh;
    width: 100%;
    position: relative;
    background-size: cover;
    background-attachment: fixed;
    background-position: center center;
  }

  .page-1 .content {
    padding-top: 3.5rem;
    color: white;
    text-align: left;
    font-size: 0.3rem;
    line-height: 0.6rem
  }

  .page-1 .content img {
    left: 0;
  }

  .top-icon {
    position:absolute;
    right:15%;
    width:17%;
    bottom:0;
  }

  .ray {
    position: absolute;
    z-index: 99;
    width: 200px;
    height: 10px;
    bottom: 100px;
    transform: rotate(30deg);
    background: linear-gradient(270deg, rgb(90, 79, 217), rgba(90, 79, 217, 0));
    border-radius: 0.1rem;
  }

  .top {
    animation: myfirst 2s infinite;
    -webkit-animation: myfirst 2s infinite;
  }

  .bottom {
    animation: myfirst2 2.5s infinite;
    -webkit-animation: myfirst2 2.5s infinite;
    animation-delay: 5s;
  }

  @keyframes myfirst {

    10% {
      left: 0px;
      top: 0px;
    }

    100% {
      left: 70vh;
      top: 95vh;
    }
  }

  @keyframes myfirst2 {

    10% {
      left: 100px;
      top: 100px;
    }

    100% {
      left: 130vh;
      top: 100vh;
    }
  }

  .page-2 {
    color: white;
    height: 10.9rem;
  }

  .page-2 video {
    width: 100%;
    height: 7.0rem;
    display: block;
    margin: 1rem auto 0;
    transform: matrix(1, 0, 0, 1, 0, 0);
    border-radius: 26px;
  }

  .page-2 h2 {
    font-size: 30px;
    margin-top: 0.5rem;
    color: white;
  }

  .page-2 h2 b {
    margin-left: 15px;
    font-size: 20px;
  }

  .page-2 p {
    line-height: 0.45rem;
    margin-top: 0.35rem;
  }

  .page-3 {
    height: 9.8rem;
    color: white;
  }

  .page-3 .page-title {
    font-size: 0.3rem;
  }

  .page-3 h2 {
    font-size: 0.5rem !important;
  }

  .page-3 .page-content {
    margin-top: 1.25rem;
  }

  .page-3 .content ul {
    display: flex;

  }

  .page-3 .content li {
    list-style-type: none;
    position: relative;
    width: 25%;
    height: 8.0rem;
  }

  .page-3 .content li h4 {
    padding-top: 1.6rem;
  }

  .page-3 .content li p {
    width: 80%;
    margin: 0.2rem auto;
    font-size: 0.16rem;
    line-height: 0.28rem;
  }

  .page-3 .content li .bg {
    background: url(https://img-pub.fbcontent.cn/ybcweapp/increase/official-site/2022/qqbu209qe.png) no-repeat 50%;
    background-size: 100%;
    -ms-transform: scale(1.07, 1.052);
    transform: scale(1.07, 1.052);
    -ms-transform-origin: center bottom;
    transform-origin: center bottom;
    transition: transform .3s ease;
  }

  .page-3 .img-top {
    width: 2.5rem;
    height: 2.5rem;
    position: absolute;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    left: 50%;
    z-index: 999;
  }

  .page-3 .active {
    transform: translate(-50%, -50%) scale(1.05);
    transition: transform 0.3s ease 0s;
  }

  .card-icon {
    width: 1.4rem;
    height: 1.4rem;
    position: absolute;
    bottom: -0.6rem;
    right: -0.2rem;
  }

  .li-main {
    width: 3.45rem;
    height: 4.4rem;
    background: url(https://img-pub.fbcontent.cn/ybcweapp/increase/official-site/2022/qz1j0xw2i.png) no-repeat;
    background-size: 100%;
    text-align: center;
    border-radius: 0.17rem;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .bg .card-icon {
    transform: translate(0.1rem, 0.3rem);
    transition: all 1.2s ease 0s;
  }

  .page-4,
  .page-5 {
    color: white;
  }

  .page-4 .page-title {
    font-size: 25px;
  }

  .page-4 h2,
  .page-5 h2 {
    margin: 10px;
    font-size: 40px !important;
  }

  .page-4 .page-content {
    margin-top: 13vh;
  }

  .page-content {
    position: absolute;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .page-title {
    text-align: center;
  }

  .page-img {
    z-index: 9;
    top: 0;
    height: 100%;
  }

  .page-6 {
    text-align: center;
    color: white;
    font-size: 40px;

  }
 .page-6 .page-content {
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    height:350px;
  }

  .page-6 .button {
    width: 200px;
    height: 60px;
    line-height: 60px;
    margin: 0.8rem auto;
    font-size: 28px;
    border-radius: 15px;
    border: 1px solid white;
    background: none;
  }

  /* 培养更全面能力*/

  .page-4 {
    height:850px;
  }
  .box {
    width: 1000px;
    margin: 50px auto;
    height:400px;
  }

  .box ul {
    list-style: none;
    height: 100%;
    display: flex;
  }

  .box ul li {
    display: block;
    flex: 1;
    height: 100%;
    position: relative;
    overflow: hidden;
    transition: 0.5s;
    border-radius: 15px;
  }

  .box ul li:nth-child(2),
  .box ul li:nth-child(3),
  .box ul li:nth-child(4) {
    margin-left: 20px;
  }

  /* li:hover{
        flex: 2.5;
      } */
  .box .flexs {
    flex: 2.5;
    border-radius:16px;
  }

  .flexs img {
    width:100%;
  }

  .box ul li:hover img {
    border: 0;

  }

  .box ul li img {
    /* width: 100%; */
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: 0.5s;
  }

  .text-mask {
    display: block;
  }

  .text-single {
    display: none;
  }

  .text-mask,
  .text-single {
    position: absolute;
    width: 100%;
    font-size: 22px;
    color: #fff;
    font-weight: 100;
    height: 100px;
    bottom: 0;
    text-align: left;
    background: linear-gradient(180deg, rgba(113, 78, 57, 0), rgba(113, 78, 57, .8));
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .tit {
    position: relative;
    margin-top: 10px;
    padding-left: 10%;
    padding-right: 13%;
  }

  .desc {
    font-weight: 400;
    font-size: 14px;
    opacity: .8;
    padding-top: 20px;
    padding-left: 10%;
    animation: fadeInDesc-data-v-c502e4e0 ease .3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  /*编程大事记*/
</style>



// WEBPACK FOOTER //
// src/components/About.vue